import { PageResponse } from 'context/PaginatedItems/types/PaginatedItems';

export const paged = <T>(items: T[], page: number, pageSize: number): PageResponse<T> => {
  const totalItems = items.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const sublistStartIndex = (page - 1) * pageSize;
  const sublistEndIndex = Math.min(sublistStartIndex + pageSize, totalItems);

  return {
    items: items.slice(sublistStartIndex, sublistEndIndex),
    totalElements: totalItems,
    page: page,
    totalPages: totalPages,
  };
};
